module.exports = __webpack_public_path__ + "img/img-1.6c1a1f5a.jpg";